<div
  class="upload-overlay"
  [plDroppable]="true"
  (dropOn)="onDrop($event)"
>
  <div class="upload-overlay-text">Drop it like it's hot!</div>
</div>
